import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { MemoryCacheStore } from './cache.model';
const defaultKeyBuilder = (...args) => {
    return args.map(arg => arg === null || arg === void 0 ? void 0 : arg.valueOf()).join('-');
};
const defaultStore = new MemoryCacheStore();
const resolveOptions = (options) => {
    var _a, _b;
    return ({
        store: (_a = options === null || options === void 0 ? void 0 : options.store) !== null && _a !== void 0 ? _a : defaultStore,
        keyBuilder: (_b = options === null || options === void 0 ? void 0 : options.keyBuilder) !== null && _b !== void 0 ? _b : defaultKeyBuilder
    });
};
function isGenerator(val) {
    return /\[object Generator|GeneratorFunction\]/.test(Object.prototype.toString.call(val));
}
export function AppCache(options) {
    return function (target, propertyKey, descriptor) {
        if (isGenerator(descriptor.value)) {
            throw new Error('Caching generators is not supported');
        }
        const resolvedOptions = resolveOptions(options);
        const cacheStore = resolvedOptions.store;
        return Object.assign(Object.assign({}, descriptor), { value: function (...args) {
                const key = `${target.constructor.name} ${propertyKey} ${resolvedOptions.keyBuilder.apply(null, args)}`;
                const data = cacheStore.get(key);
                if (!data) {
                    let apply = descriptor.value.apply(this, args);
                    if (apply instanceof Observable) {
                        cacheStore.save(key, apply.pipe(shareReplay(1)));
                    }
                    else {
                        cacheStore.save(key, apply);
                    }
                    return apply;
                }
                else {
                    return data;
                }
            } });
    };
}
export function InvalidateAppCache(options) {
    return function (target, propertyKey, descriptor) {
        const resolvedOptions = resolveOptions(options);
        return Object.assign(Object.assign({}, descriptor), { value: function (...args) {
                resolvedOptions.store.clean();
                return descriptor.value.apply(this, args);
            } });
    };
}
//# sourceMappingURL=cache.decorator.js.map